module.exports = new __parcel__URL__("giant-tree.b3c678f7.webp").toString();